import React from "react";
import classes from "./Features.module.css";

const comfortFeatures = {
  airConditioning: "Air Conditioning",
  climateControl: "Climate control",
  heatedSeats: "Heated seats",
  cruiseControl: "Cruise control",
  sunroof: "Sunroof",
  leatherInterior: "Leather interior",
  touchscreenDisplay: "Touchscreen display",
  usbChargingPort: "USB charging port",
  keylessEntry: "Keyless entry",
  lumbarSupport: "Lumbar support",
};

const safetyFeatures = {
  absBrakes: "ABS brakes",
  laneDepartureWarning: "Lane Departure Warning",
  parkingSensors: "Parking Sensors",
  electronicStabilityControl: "Electronic Stability Control",
  airbags: "Airbags",
  collisionAvoidance: "Collision Avoidance",
  tractionControl: "Traction Control",
  blindSpotMonitoring: "Blind Spot Monitoring",
  tirePressureMonitoring: "Tire Pressure Monitoring",
};

const FeatureGroup = ({ title, featureSet, groupKey, formData, updateFeature }) => (
  <div className={classes.card}>
    <h5 className={classes.title}>{title}</h5>
    <div className={classes.grid}>
      {Object.entries(featureSet).map(([key, label]) => (
        <label key={key} className={classes.checkboxLabel}>
          <input
            type="checkbox"
            checked={formData.features[groupKey]?.[key] || false}
            onChange={() => updateFeature(groupKey, key)}
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  </div>
);

const Features = ({ formData, updateFormData }) => {
  const updateFeature = (group, featureKey) => {
    const prevGroup = formData.features[group] || {};
    const updatedGroup = {
      ...prevGroup,
      [featureKey]: !prevGroup[featureKey],
    };

    updateFormData({
      features: {
        ...formData.features,
        [group]: updatedGroup,
      },
    });
  };

  return (
    <div className={classes.wrapper}>
      <h4>Features</h4>
      <FeatureGroup
        title="Comfort & Convenience"
        featureSet={comfortFeatures}
        groupKey="comfortAndConvenience"
        formData={formData}
        updateFeature={updateFeature}
      />
      <FeatureGroup
        title="Safety"
        featureSet={safetyFeatures}
        groupKey="safety"
        formData={formData}
        updateFeature={updateFeature}
      />
    </div>
  );
};

export default Features;